import { useState } from "react";
import iconPlus from "../../assets/icon-plus.svg";

type BlockType = "heading" | "text" | "button";

interface BlockPickerProps {
  onSelect: (type: BlockType) => void;
}

export function BlockPicker({ onSelect }: BlockPickerProps) {
  const [open, setOpen] = useState(false);

  function handleSelect(type: BlockType) {
    onSelect(type);
    setOpen(false);
  }

  return (
    <div className="relative inline-flex">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-9 h-9 rounded-full bg-brand-brown-6 flex items-center justify-center hover:opacity-80"
      >
        <img src={iconPlus} alt="Add block" width={20} height={20} className="text-brand-brown" />
      </button>

      {open && (
        <div className="absolute left-full ml-2 top-0 bg-bg-primary rounded-xl shadow-[0_6px_12px_var(--color-shadow-dropdown)] overflow-hidden z-10">
          <button
            onClick={() => handleSelect("heading")}
            className="w-full px-4 py-3 text-sm text-text-primary hover:bg-bg-secondary text-left whitespace-nowrap"
          >
            H2
          </button>
          <div className="border-t border-stroke-primary" />
          <button
            onClick={() => handleSelect("text")}
            className="w-full px-4 py-3 text-sm text-text-primary hover:bg-bg-secondary text-left whitespace-nowrap"
          >
            Text
          </button>
          <div className="border-t border-stroke-primary" />
          <button
            onClick={() => handleSelect("button")}
            className="w-full px-4 py-3 text-sm text-text-primary hover:bg-bg-secondary text-left whitespace-nowrap"
          >
            Button
          </button>
        </div>
      )}
    </div>
  );
}
